// @charset "utf-8"
// 验证问句长度大于0小于200
export function questionVal (val, max, min) {
    if (max !== undefined && val.length > max) {
        return false
    }

    if (min !== undefined && val.length < min) {
        return false
    }

    return true
}
// 验证持股周期大于0的整数集合
export function numberDays (val, num) {
    if (num) {
        if (!(/(^(([1-9]\d+)|[2-9])(,(([1-9]\d+)|[2-9]))*$)/.test(val))) {
            return false
        } else {
            return true
        }
    } else {
        if (!(/(^[1-9]\d*(,[1-9]\d*)*$)/.test(val))) {
            return false
        } else {
            return true
        }
    }
}
// 验证评论长度大于0小于等于400
export function commentVal (val) {
    if (val.length > 400 || val.length <= 0) {
        return false
    } else {
        return true
    }
}
// 验证单个标签16字，标签上限10个
export function labelVal (val) {
    let arr = val.split(' ')
    // let arry = []
    // if (val.length === 0) {
    //     return 0
    // } else {
    let arry = arr.filter(x => x !== '')
    if (arry.length > 10) {
        return 1
    } else {
        for (let i = 0; i < arry.length; i++) {
            if (arry[i].length > 16) {
                return 2
            } else {
                return arry.join(' ')
            }
        }
    }
    // }
}
// 验证数字为正数（包含小数）
export function profitLossVal (val) {
    if (!(/((^[1-9]\d*$)|(^[0-9]\d*\.\d+$))/.test(val))) {
        return false
    } else {
        return true
    }
}



// WEBPACK FOOTER //
// ./src/lib/formValidation.js